import { User, createDeleteUserMutation } from 'shared/api';
import { ConfirmModalModel, createConfirmModalModel, declareModalData } from 'shared/lib';

export type DeleteUserModel = ConfirmModalModel<User, number, null>;

export const createDeleteUserModel = (): DeleteUserModel => {
	const deleteUserMutation = createDeleteUserMutation();

	const model = createConfirmModalModel<User, number, null>({
		modalData: declareModalData<User>(),
		mapModalData: ({ id }) => id,
		mutation: deleteUserMutation,
		successMessageKey: 'delete-user.success',
	});

	return model;
};
